import React, { FC, memo, useEffect, useRef } from 'react';

import { IEnvelopeProps as IProps } from '@views/envelopes/types';

import EnvelopeCheckbox from './EnvelopeCheckbox';
import EnvelopeSubject from './EnvelopeSubject';
import EnvelopeStatus from './EnvelopeStatus';
import EnvelopLastChange from './EnvelopeLastChange';
import EnvelopeActions from './EnvelopeActions';
import EnvelopeIcons from '@views/envelopes/components/EnvelopesTable/EnvelopeItem/EnvelopeIcons';
import EnvelopeDynamicField from './EnvelopeDynamicField';
import { getEnvelopeCheckboxKey } from '@hooks/envelopes';
import cn from 'classnames';
import styles from './EnvelopeItem.module.scss';

const EnvelopeItem: FC<IProps> = ({
  envelope,
  envelopeFields,
  availableLabels,
  checkbox,
  selectedCheckbox,
  currentBoxOguid,
  idx
}) => {
  const {
    oguid,
    direction,
    directions,
    allowedActions,
    subject,
    recipients,
    flowState,
    taskCompletedCount,
    taskTotalCount,
    lastActionDateTime,
    fields,
  } = envelope

  const trRef = useRef<HTMLTableRowElement>(null);

  useEffect(() => {
    if (idx === 0) {
      trRef.current?.scrollIntoView({
        behavior: "auto",
        block: "end",
      });
    }
  }, [idx]);

  return (
    <tr className={cn(!envelope.isRead && styles.unreadRow)} ref={trRef}>
      <EnvelopeCheckbox
        oguid={getEnvelopeCheckboxKey(envelope)}
        checkbox={checkbox}
        selectedCheckbox={selectedCheckbox}
      />
      <EnvelopeIcons
        directions={directions}
        allowedActions={allowedActions}
      />
      <EnvelopeSubject
        subject={subject}
        recipients={recipients}
        oguid={oguid}
        boxOguid={currentBoxOguid}
        direction={direction}
        labels={envelope.labels}
        availableLabels={availableLabels}
      />
      {envelopeFields.map((field) => (
        <EnvelopeDynamicField
          key={field.systemKey}
          field={field}
          fields={fields}
        />
      ))}
      <EnvelopeStatus
        flowState={flowState}
        taskCompletedCount={taskCompletedCount}
        taskTotalCount={taskTotalCount}
      />
      <EnvelopLastChange
        lastActionDateTime={lastActionDateTime}
      />
      <EnvelopeActions
        envelope={envelope}
        oguid={oguid}
        allowedActions={allowedActions}
        subject={subject}
        boxOguid={currentBoxOguid}
      />
    </tr>
  )
}

export default memo(EnvelopeItem)
